/**
 * authedFetch — wrapper de fetch com Authorization: Bearer + credentials: include.
 *
 * Reutiliza o access token em memoria via o mesmo hook do auth-store usado
 * pelo apiClient (sem duplicar logica nem usar require, que quebra em ESM).
 * Usado pelo useChat do @ai-sdk/react para autenticar o stream SSE.
 */

import { getAccessTokenSafe } from './api-client';

const RAW_API_URL = (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, '');
const API_URL = RAW_API_URL ?? 'http://localhost:3001';

export function authedFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const bearer = getAccessTokenSafe();

  const url =
    typeof input === 'string' && input.startsWith('/api/')
      ? `${API_URL}${input}`
      : input;

  const headers: Record<string, string> = {
    ...(init?.headers as Record<string, string> | undefined),
  };

  if (bearer && !headers['Authorization']) {
    headers['Authorization'] = `Bearer ${bearer}`;
  }

  return fetch(url, {
    ...init,
    credentials: 'include',
    headers,
  });
}
